import styled from 'styled-components'
import Text from '../atoms/Text';
import ClearableInput from './ClearableInput';
import PasswordInput from './auth/PasswordInput';

const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 50px;
`;
const LabelWrapper = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
`
const RequiredCircle = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.status.error};
`

const LabeledInput = ({label, placeholder, value, onChange, required=false, readOnly=false, type="text", $error, ...props}) => {  
  return (
    <Container>
      <label>
        <LabelWrapper>
          <Text as="label" variant="body2" weight="medium">{label}</Text>
          {required && <RequiredCircle aria-label="필수 입력 항목"/>}
        </LabelWrapper>
        {type === "password" ? (
          <PasswordInput
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            $error={$error}
            {...props}
          />
        ) : (
          <ClearableInput
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            readOnly={readOnly}
            aria-readonly={readOnly}
            $error={$error}
            {...props}
          />
        )}
      </label>
    </Container>
  )
}

export default LabeledInput
